import { LicenseManager } from 'ag-grid-enterprise';

const AG_GRID_KEY =
  'CompanyName=TrueBuilt Software,LicensedApplication=TrueBuilt Software,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=3,LicensedProductionInstancesCount=1,AssetReference=AG-033391,SupportServicesEnd=27_September_2023_[v2]_MTY5NTc2OTIwMDAwMA==9d60ffc1e6e7cc282486519dfbfe6010';

LicenseManager.setLicenseKey(AG_GRID_KEY);

// import 'ag-grid-enterprise';
